module.exports = __webpack_public_path__ + "vue/img/logo_black.f3cef60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/logo_black.svg
// module id = M6Ud
// module chunks = 1